import {login, logout} from '@/api/login'
import {getInfo} from '@/api/user'
import {getUserId, setUserId, removeUserId} from '@/utils/cookie'
import {Encrypt,Decrypt} from '@/utils/caypto'
import { message} from '../../utils/message'
import {showLoading, hideLoading} from '../../utils/loading';
const user = {
  state: {
    userId: '',
    roles: null,
    users:null,
  },

  mutations: {
    SET_USER_ID: (state, id) => {
      state.userId = id
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_USERS: (state, users) => {
      state.users = users
    },
  },

  actions: {
    // 登录
    Login({commit}, userInfo) {
      showLoading();
      return new Promise((resolve, reject) => {
        login({username:userInfo.username,password:userInfo.password}).then(response => {
          const data = response.data;
          if (data.code == 0) {
            localStorage.setItem('web_user',JSON.stringify(data.result));
            setUserId(data.result.id)
            hideLoading();
          }else if(data.code!=0){
            this.loading = false
            hideLoading();
            message(data.message,"error")
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({commit, state}) {
      return new Promise((resolve, reject) => {
        getInfo(getUserId()).then(response => {
          const data = response.data.result;
          sessionStorage.setItem('web_user', JSON.stringify(data));
          // commit('SET_USERS', data);
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({commit, state}) {
      showLoading
      return new Promise((resolve, reject) => {
        logout().then(() => {
          hideLoading();
          removeUserId()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js